export const layout = {
  name: 'cose-bilkent',
  // idealEdgeLength: 5,
  // fit: true,
  // padding: 30,
};

export const graphStyleSheet: any = [
  {
    selector: 'node',
    style: {
      // 'label': 'data(id)',
      label: 'data(label)',
      content: 'data(label)',
      'text-valign': 'center',
      'text-halign': 'center',
      'font-size': '12px',
      width: 'data(size)',
      height: 'data(size)',
      'background-color': '#51BDC3',
      'color': 'black',
      'background-opacity': 0.5,
      'border-color': '#51BDC3',
      'border-width': 2,
    }
  },
  {
    selector: 'node:selected',
    style: {
      // 'label': 'data(id)',
      label: 'data(label)',
      content: 'data(label)',
      width: 'data(size)',
      height: 'data(size)',
      'background-color': '#51BDC3',
      'color': 'black',
      'background-opacity': 1,
      'border-color': '#51BDC3',
      'border-width': 2,
    }
  },
  {
    selector: 'edge',
    style: {
      // label: 'data(label)',
      width: 2,
      'line-color': '#51BDC3',
      'target-distance-from-node': 0,
      'source-distance-from-node': 0,
      'curve-style': 'bezier',
      'border-width': 2
    }
  },
  {
    selector: "core",
    style: {
      'selection-box-color': "#51BDC3",
      'selection-box-border-color': "#51BDC3",
      'selection-box-border-width': "2",
      'selection-box-opacity': "0.5",
      'active-bg-color': "#51BDC3",
    }
  }
];
